export default "__VITE_ASSET__CVNfUfn0__"